import { DateFormatType } from './date-format-key'
import { HumanDateFormatType } from './human-date-format-type'
import { TimeFormatType } from './time-format-key'
import { buildDateFormatMap } from './build-format-map'
import { LOCAL_STORAGE_KEYS } from './local-storage-keys'
import { normalizeDateFormat } from './normalize-date-format'
import { normalizeTimeFormat } from './normalize-time-format'

function readStoredTimeFormat(): TimeFormatType | null {
  if (typeof localStorage === 'undefined') {
    return null
  }

  return normalizeTimeFormat(localStorage.getItem(LOCAL_STORAGE_KEYS.time))
}

function readStoredDateFormat(): DateFormatType | null {
  if (typeof localStorage === 'undefined') {
    return null
  }

  return normalizeDateFormat(localStorage.getItem(LOCAL_STORAGE_KEYS.date))
}

export function getFormatKeySync(key: HumanDateFormatType | string): string {
  const formatMap = buildDateFormatMap(readStoredTimeFormat(), readStoredDateFormat())
  return (formatMap as Record<string, string>)[key] ?? key
}
